import {
  Assessment,
  AssignmentInd as CaseIcon,
  CollectionsBookmark as CollectionsBookmarkIcon,
  Home as HomeIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

import { Role } from 'API';
import { FIRM_SLUG } from 'services/firm';

export const ROUTES = {
  admin: '/admin',
  cases: '/cases',
  companies: '/companies',
  contacts: '/people',
  contactsLanding: '/contacts',
  dashboard: '/',
  firm: `/companies/${FIRM_SLUG}`,
  home: '/',
  notifications: '/notifications',
  people: '/people',
  processRequests: '/process-requests',
  resources: '/resources',
  tasks: '/tasks',
  createReport: '/create-report',
  reports: '/reports',
};

export const NAV_CONFIG: NavConfig = {
  cases: {
    icon: CaseIcon,
    label: 'Cases',
    route: ROUTES.cases,
  },
  home: {
    icon: HomeIcon,
    label: 'Home',
    route: ROUTES.dashboard,
  },
  people: {
    icon: PeopleIcon,
    label: 'Contacts',
    route: ROUTES.contactsLanding,
  },
  resources: {
    icon: CollectionsBookmarkIcon,
    label: 'Resources',
    route: ROUTES.resources,
  },
  settings: {
    icon: SettingsIcon,
    label: 'Settings',
    route: ROUTES.admin,
  },
  reports: {
    icon: Assessment,
    label: 'Reports',
    route: ROUTES.reports,
  },
};

export const ROLE_NAVS: RoleNavs = {
  [Role.ADMIN]: [
    NAV_CONFIG.home,
    NAV_CONFIG.cases,
    NAV_CONFIG.people,
    NAV_CONFIG.resources,
    NAV_CONFIG.settings,
    NAV_CONFIG.reports,
  ],
  [Role.TEAMMEMBER]: [
    NAV_CONFIG.home,
    NAV_CONFIG.cases,
    NAV_CONFIG.people,
    NAV_CONFIG.resources,
    NAV_CONFIG.reports,
  ],
  [Role.EMPLOYER]: [
    NAV_CONFIG.home,
    NAV_CONFIG.cases,
    NAV_CONFIG.people,
    NAV_CONFIG.resources,
    NAV_CONFIG.reports,
  ],
  [Role.FOREIGNNATIONAL]: [
    NAV_CONFIG.home,
    NAV_CONFIG.people,
    NAV_CONFIG.resources,
  ],
};

export const EXTERNAL = {
  uscis: 'https://www.uscis.gov/',
};
